export default __webpack_public_path__ + "static/media/020-parking lot.abcdd1af.svg";